/**
 * @generated SignedSource<<333ef5e4d9ff07c102703ce873f8a7cf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerInfo_viewer$data = {
  readonly suppressNewSellerSignals: boolean | null;
  readonly " $fragmentType": "PdpSharedSellerInfo_viewer";
};
export type PdpSharedSellerInfo_viewer$key = {
  readonly " $data"?: PdpSharedSellerInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerInfo_viewer",
  "selections": [
    {
      "alias": "suppressNewSellerSignals",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "suppressNewSellerSignals"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bd81b457c1c3a1e37eb0833058f896a5";

export default node;
